/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ObservableLevelResponse } from './ObservableLevelResponse';
import {
    ObservableLevelResponseFromJSON,
    ObservableLevelResponseFromJSONTyped,
    ObservableLevelResponseToJSON,
    ObservableLevelResponseToJSONTyped,
} from './ObservableLevelResponse';
import type { PartCategoryResponse } from './PartCategoryResponse';
import {
    PartCategoryResponseFromJSON,
    PartCategoryResponseFromJSONTyped,
    PartCategoryResponseToJSON,
    PartCategoryResponseToJSONTyped,
} from './PartCategoryResponse';
import type { PartManufacturerResponse } from './PartManufacturerResponse';
import {
    PartManufacturerResponseFromJSON,
    PartManufacturerResponseFromJSONTyped,
    PartManufacturerResponseToJSON,
    PartManufacturerResponseToJSONTyped,
} from './PartManufacturerResponse';
import type { PartLocationResponse } from './PartLocationResponse';
import {
    PartLocationResponseFromJSON,
    PartLocationResponseFromJSONTyped,
    PartLocationResponseToJSON,
    PartLocationResponseToJSONTyped,
} from './PartLocationResponse';
import type { AssetModelResponse } from './AssetModelResponse';
import {
    AssetModelResponseFromJSON,
    AssetModelResponseFromJSONTyped,
    AssetModelResponseToJSON,
    AssetModelResponseToJSONTyped,
} from './AssetModelResponse';
import type { PartDimensionResponse } from './PartDimensionResponse';
import {
    PartDimensionResponseFromJSON,
    PartDimensionResponseFromJSONTyped,
    PartDimensionResponseToJSON,
    PartDimensionResponseToJSONTyped,
} from './PartDimensionResponse';
import type { PartResponse } from './PartResponse';
import {
    PartResponseFromJSON,
    PartResponseFromJSONTyped,
    PartResponseToJSON,
    PartResponseToJSONTyped,
} from './PartResponse';
import type { ObservableItemResponse } from './ObservableItemResponse';
import {
    ObservableItemResponseFromJSON,
    ObservableItemResponseFromJSONTyped,
    ObservableItemResponseToJSON,
    ObservableItemResponseToJSONTyped,
} from './ObservableItemResponse';
import type { SiteDiggingConditionResponse } from './SiteDiggingConditionResponse';
import {
    SiteDiggingConditionResponseFromJSON,
    SiteDiggingConditionResponseFromJSONTyped,
    SiteDiggingConditionResponseToJSON,
    SiteDiggingConditionResponseToJSONTyped,
} from './SiteDiggingConditionResponse';
import type { InspectionResponse } from './InspectionResponse';
import {
    InspectionResponseFromJSON,
    InspectionResponseFromJSONTyped,
    InspectionResponseToJSON,
    InspectionResponseToJSONTyped,
} from './InspectionResponse';
import type { AssetInspectionResponse } from './AssetInspectionResponse';
import {
    AssetInspectionResponseFromJSON,
    AssetInspectionResponseFromJSONTyped,
    AssetInspectionResponseToJSON,
    AssetInspectionResponseToJSONTyped,
} from './AssetInspectionResponse';
import type { InspectionCategoryResponse } from './InspectionCategoryResponse';
import {
    InspectionCategoryResponseFromJSON,
    InspectionCategoryResponseFromJSONTyped,
    InspectionCategoryResponseToJSON,
    InspectionCategoryResponseToJSONTyped,
} from './InspectionCategoryResponse';
import type { MineLocationResponse } from './MineLocationResponse';
import {
    MineLocationResponseFromJSON,
    MineLocationResponseFromJSONTyped,
    MineLocationResponseToJSON,
    MineLocationResponseToJSONTyped,
} from './MineLocationResponse';
import type { ObservationResponse } from './ObservationResponse';
import {
    ObservationResponseFromJSON,
    ObservationResponseFromJSONTyped,
    ObservationResponseToJSON,
    ObservationResponseToJSONTyped,
} from './ObservationResponse';
import type { EquipmentPartResponse } from './EquipmentPartResponse';
import {
    EquipmentPartResponseFromJSON,
    EquipmentPartResponseFromJSONTyped,
    EquipmentPartResponseToJSON,
    EquipmentPartResponseToJSONTyped,
} from './EquipmentPartResponse';
import type { DataTypeResponse } from './DataTypeResponse';
import {
    DataTypeResponseFromJSON,
    DataTypeResponseFromJSONTyped,
    DataTypeResponseToJSON,
    DataTypeResponseToJSONTyped,
} from './DataTypeResponse';
import type { EquipmentCategoryResponse } from './EquipmentCategoryResponse';
import {
    EquipmentCategoryResponseFromJSON,
    EquipmentCategoryResponseFromJSONTyped,
    EquipmentCategoryResponseToJSON,
    EquipmentCategoryResponseToJSONTyped,
} from './EquipmentCategoryResponse';
import type { PartDimensionThresholdResponse } from './PartDimensionThresholdResponse';
import {
    PartDimensionThresholdResponseFromJSON,
    PartDimensionThresholdResponseFromJSONTyped,
    PartDimensionThresholdResponseToJSON,
    PartDimensionThresholdResponseToJSONTyped,
} from './PartDimensionThresholdResponse';
import type { PartTypeMeasurementToolResponse } from './PartTypeMeasurementToolResponse';
import {
    PartTypeMeasurementToolResponseFromJSON,
    PartTypeMeasurementToolResponseFromJSONTyped,
    PartTypeMeasurementToolResponseToJSON,
    PartTypeMeasurementToolResponseToJSONTyped,
} from './PartTypeMeasurementToolResponse';
import type { InspectionStatusResponse } from './InspectionStatusResponse';
import {
    InspectionStatusResponseFromJSON,
    InspectionStatusResponseFromJSONTyped,
    InspectionStatusResponseToJSON,
    InspectionStatusResponseToJSONTyped,
} from './InspectionStatusResponse';
import type { AssetTypeResponse } from './AssetTypeResponse';
import {
    AssetTypeResponseFromJSON,
    AssetTypeResponseFromJSONTyped,
    AssetTypeResponseToJSON,
    AssetTypeResponseToJSONTyped,
} from './AssetTypeResponse';
import type { ObservableItemActionTypeResponse } from './ObservableItemActionTypeResponse';
import {
    ObservableItemActionTypeResponseFromJSON,
    ObservableItemActionTypeResponseFromJSONTyped,
    ObservableItemActionTypeResponseToJSON,
    ObservableItemActionTypeResponseToJSONTyped,
} from './ObservableItemActionTypeResponse';
import type { AssetResponse } from './AssetResponse';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './AssetResponse';
import type { DimensionTypeResponse } from './DimensionTypeResponse';
import {
    DimensionTypeResponseFromJSON,
    DimensionTypeResponseFromJSONTyped,
    DimensionTypeResponseToJSON,
    DimensionTypeResponseToJSONTyped,
} from './DimensionTypeResponse';
import type { ObservableActionTypeResponse } from './ObservableActionTypeResponse';
import {
    ObservableActionTypeResponseFromJSON,
    ObservableActionTypeResponseFromJSONTyped,
    ObservableActionTypeResponseToJSON,
    ObservableActionTypeResponseToJSONTyped,
} from './ObservableActionTypeResponse';
import type { EquipmentPartConfigurationResponse } from './EquipmentPartConfigurationResponse';
import {
    EquipmentPartConfigurationResponseFromJSON,
    EquipmentPartConfigurationResponseFromJSONTyped,
    EquipmentPartConfigurationResponseToJSON,
    EquipmentPartConfigurationResponseToJSONTyped,
} from './EquipmentPartConfigurationResponse';
import type { InspectionCategoryTypeResponse } from './InspectionCategoryTypeResponse';
import {
    InspectionCategoryTypeResponseFromJSON,
    InspectionCategoryTypeResponseFromJSONTyped,
    InspectionCategoryTypeResponseToJSON,
    InspectionCategoryTypeResponseToJSONTyped,
} from './InspectionCategoryTypeResponse';
import type { EquipmentResponse } from './EquipmentResponse';
import {
    EquipmentResponseFromJSON,
    EquipmentResponseFromJSONTyped,
    EquipmentResponseToJSON,
    EquipmentResponseToJSONTyped,
} from './EquipmentResponse';
import type { AssetManufacturerResponse } from './AssetManufacturerResponse';
import {
    AssetManufacturerResponseFromJSON,
    AssetManufacturerResponseFromJSONTyped,
    AssetManufacturerResponseToJSON,
    AssetManufacturerResponseToJSONTyped,
} from './AssetManufacturerResponse';
import type { InspectionTypeResponse } from './InspectionTypeResponse';
import {
    InspectionTypeResponseFromJSON,
    InspectionTypeResponseFromJSONTyped,
    InspectionTypeResponseToJSON,
    InspectionTypeResponseToJSONTyped,
} from './InspectionTypeResponse';
import type { EquipmentTypeResponse } from './EquipmentTypeResponse';
import {
    EquipmentTypeResponseFromJSON,
    EquipmentTypeResponseFromJSONTyped,
    EquipmentTypeResponseToJSON,
    EquipmentTypeResponseToJSONTyped,
} from './EquipmentTypeResponse';
import type { SiteResponse } from './SiteResponse';
import {
    SiteResponseFromJSON,
    SiteResponseFromJSONTyped,
    SiteResponseToJSON,
    SiteResponseToJSONTyped,
} from './SiteResponse';
import type { UnitResponse } from './UnitResponse';
import {
    UnitResponseFromJSON,
    UnitResponseFromJSONTyped,
    UnitResponseToJSON,
    UnitResponseToJSONTyped,
} from './UnitResponse';
import type { PartTypeResponse } from './PartTypeResponse';
import {
    PartTypeResponseFromJSON,
    PartTypeResponseFromJSONTyped,
    PartTypeResponseToJSON,
    PartTypeResponseToJSONTyped,
} from './PartTypeResponse';
import type { CustomerResponse } from './CustomerResponse';
import {
    CustomerResponseFromJSON,
    CustomerResponseFromJSONTyped,
    CustomerResponseToJSON,
    CustomerResponseToJSONTyped,
} from './CustomerResponse';
import type { EquipmentConfigurationResponse } from './EquipmentConfigurationResponse';
import {
    EquipmentConfigurationResponseFromJSON,
    EquipmentConfigurationResponseFromJSONTyped,
    EquipmentConfigurationResponseToJSON,
    EquipmentConfigurationResponseToJSONTyped,
} from './EquipmentConfigurationResponse';

/**
 * 
 * @export
 * @interface InspectionSyncItemsResponse
 */
export interface InspectionSyncItemsResponse {
    /**
     * 
     * @type {Array<AssetResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    assets?: Array<AssetResponse>;
    /**
     * 
     * @type {Array<AssetInspectionResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    assetInspections?: Array<AssetInspectionResponse>;
    /**
     * 
     * @type {Array<AssetManufacturerResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    assetManufacturers?: Array<AssetManufacturerResponse>;
    /**
     * 
     * @type {Array<AssetModelResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    assetModels?: Array<AssetModelResponse>;
    /**
     * 
     * @type {Array<AssetTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    assetTypes?: Array<AssetTypeResponse>;
    /**
     * 
     * @type {Array<CustomerResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    customers?: Array<CustomerResponse>;
    /**
     * 
     * @type {Array<DataTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    dataTypes?: Array<DataTypeResponse>;
    /**
     * 
     * @type {Array<DimensionTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    dimensionTypes?: Array<DimensionTypeResponse>;
    /**
     * 
     * @type {Array<EquipmentCategoryResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    equipmentCategories?: Array<EquipmentCategoryResponse>;
    /**
     * 
     * @type {Array<EquipmentConfigurationResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    equipmentConfigurations?: Array<EquipmentConfigurationResponse>;
    /**
     * 
     * @type {Array<EquipmentResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    equipments?: Array<EquipmentResponse>;
    /**
     * 
     * @type {Array<EquipmentPartResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    equipmentParts?: Array<EquipmentPartResponse>;
    /**
     * 
     * @type {Array<EquipmentPartConfigurationResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    equipmentPartConfigurations?: Array<EquipmentPartConfigurationResponse>;
    /**
     * 
     * @type {Array<EquipmentTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    equipmentTypes?: Array<EquipmentTypeResponse>;
    /**
     * 
     * @type {Array<InspectionCategoryResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    inspectionCategories?: Array<InspectionCategoryResponse>;
    /**
     * 
     * @type {Array<InspectionCategoryTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    inspectionCategoryTypes?: Array<InspectionCategoryTypeResponse>;
    /**
     * 
     * @type {Array<InspectionResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    inspections?: Array<InspectionResponse>;
    /**
     * 
     * @type {Array<InspectionStatusResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    inspectionStatuses?: Array<InspectionStatusResponse>;
    /**
     * 
     * @type {Array<InspectionTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    inspectionTypes?: Array<InspectionTypeResponse>;
    /**
     * 
     * @type {Array<MineLocationResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    mineLocations?: Array<MineLocationResponse>;
    /**
     * 
     * @type {Array<ObservableActionTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    observableActionTypes?: Array<ObservableActionTypeResponse>;
    /**
     * 
     * @type {Array<ObservableItemResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    observableItems?: Array<ObservableItemResponse>;
    /**
     * 
     * @type {Array<ObservableItemActionTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    observableItemActionTypes?: Array<ObservableItemActionTypeResponse>;
    /**
     * 
     * @type {Array<ObservableLevelResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    observableLevels?: Array<ObservableLevelResponse>;
    /**
     * 
     * @type {Array<ObservationResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    observations?: Array<ObservationResponse>;
    /**
     * 
     * @type {Array<PartCategoryResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partCategories?: Array<PartCategoryResponse>;
    /**
     * 
     * @type {Array<PartResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    parts?: Array<PartResponse>;
    /**
     * 
     * @type {Array<PartLocationResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partLocations?: Array<PartLocationResponse>;
    /**
     * 
     * @type {Array<PartManufacturerResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partManufacturers?: Array<PartManufacturerResponse>;
    /**
     * 
     * @type {Array<PartTypeResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partTypes?: Array<PartTypeResponse>;
    /**
     * 
     * @type {Array<PartTypeMeasurementToolResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partTypeMeasurementTools?: Array<PartTypeMeasurementToolResponse>;
    /**
     * 
     * @type {Array<PartDimensionResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partDimensions?: Array<PartDimensionResponse>;
    /**
     * 
     * @type {Array<PartDimensionThresholdResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    partDimensionThresholds?: Array<PartDimensionThresholdResponse>;
    /**
     * 
     * @type {Array<SiteResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    sites?: Array<SiteResponse>;
    /**
     * 
     * @type {Array<SiteDiggingConditionResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    siteDiggingConditions?: Array<SiteDiggingConditionResponse>;
    /**
     * 
     * @type {Array<UnitResponse>}
     * @memberof InspectionSyncItemsResponse
     */
    units?: Array<UnitResponse>;
}

/**
 * Check if a given object implements the InspectionSyncItemsResponse interface.
 */
export function instanceOfInspectionSyncItemsResponse(value: object): value is InspectionSyncItemsResponse {
    return true;
}

export function InspectionSyncItemsResponseFromJSON(json: any): InspectionSyncItemsResponse {
    return InspectionSyncItemsResponseFromJSONTyped(json, false);
}

export function InspectionSyncItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionSyncItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assets': json['assets'] == null ? undefined : ((json['assets'] as Array<any>).map(AssetResponseFromJSON)),
        'assetInspections': json['assetInspections'] == null ? undefined : ((json['assetInspections'] as Array<any>).map(AssetInspectionResponseFromJSON)),
        'assetManufacturers': json['assetManufacturers'] == null ? undefined : ((json['assetManufacturers'] as Array<any>).map(AssetManufacturerResponseFromJSON)),
        'assetModels': json['assetModels'] == null ? undefined : ((json['assetModels'] as Array<any>).map(AssetModelResponseFromJSON)),
        'assetTypes': json['assetTypes'] == null ? undefined : ((json['assetTypes'] as Array<any>).map(AssetTypeResponseFromJSON)),
        'customers': json['customers'] == null ? undefined : ((json['customers'] as Array<any>).map(CustomerResponseFromJSON)),
        'dataTypes': json['dataTypes'] == null ? undefined : ((json['dataTypes'] as Array<any>).map(DataTypeResponseFromJSON)),
        'dimensionTypes': json['dimensionTypes'] == null ? undefined : ((json['dimensionTypes'] as Array<any>).map(DimensionTypeResponseFromJSON)),
        'equipmentCategories': json['equipmentCategories'] == null ? undefined : ((json['equipmentCategories'] as Array<any>).map(EquipmentCategoryResponseFromJSON)),
        'equipmentConfigurations': json['equipmentConfigurations'] == null ? undefined : ((json['equipmentConfigurations'] as Array<any>).map(EquipmentConfigurationResponseFromJSON)),
        'equipments': json['equipments'] == null ? undefined : ((json['equipments'] as Array<any>).map(EquipmentResponseFromJSON)),
        'equipmentParts': json['equipmentParts'] == null ? undefined : ((json['equipmentParts'] as Array<any>).map(EquipmentPartResponseFromJSON)),
        'equipmentPartConfigurations': json['equipmentPartConfigurations'] == null ? undefined : ((json['equipmentPartConfigurations'] as Array<any>).map(EquipmentPartConfigurationResponseFromJSON)),
        'equipmentTypes': json['equipmentTypes'] == null ? undefined : ((json['equipmentTypes'] as Array<any>).map(EquipmentTypeResponseFromJSON)),
        'inspectionCategories': json['inspectionCategories'] == null ? undefined : ((json['inspectionCategories'] as Array<any>).map(InspectionCategoryResponseFromJSON)),
        'inspectionCategoryTypes': json['inspectionCategoryTypes'] == null ? undefined : ((json['inspectionCategoryTypes'] as Array<any>).map(InspectionCategoryTypeResponseFromJSON)),
        'inspections': json['inspections'] == null ? undefined : ((json['inspections'] as Array<any>).map(InspectionResponseFromJSON)),
        'inspectionStatuses': json['inspectionStatuses'] == null ? undefined : ((json['inspectionStatuses'] as Array<any>).map(InspectionStatusResponseFromJSON)),
        'inspectionTypes': json['inspectionTypes'] == null ? undefined : ((json['inspectionTypes'] as Array<any>).map(InspectionTypeResponseFromJSON)),
        'mineLocations': json['mineLocations'] == null ? undefined : ((json['mineLocations'] as Array<any>).map(MineLocationResponseFromJSON)),
        'observableActionTypes': json['observableActionTypes'] == null ? undefined : ((json['observableActionTypes'] as Array<any>).map(ObservableActionTypeResponseFromJSON)),
        'observableItems': json['observableItems'] == null ? undefined : ((json['observableItems'] as Array<any>).map(ObservableItemResponseFromJSON)),
        'observableItemActionTypes': json['observableItemActionTypes'] == null ? undefined : ((json['observableItemActionTypes'] as Array<any>).map(ObservableItemActionTypeResponseFromJSON)),
        'observableLevels': json['observableLevels'] == null ? undefined : ((json['observableLevels'] as Array<any>).map(ObservableLevelResponseFromJSON)),
        'observations': json['observations'] == null ? undefined : ((json['observations'] as Array<any>).map(ObservationResponseFromJSON)),
        'partCategories': json['partCategories'] == null ? undefined : ((json['partCategories'] as Array<any>).map(PartCategoryResponseFromJSON)),
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(PartResponseFromJSON)),
        'partLocations': json['partLocations'] == null ? undefined : ((json['partLocations'] as Array<any>).map(PartLocationResponseFromJSON)),
        'partManufacturers': json['partManufacturers'] == null ? undefined : ((json['partManufacturers'] as Array<any>).map(PartManufacturerResponseFromJSON)),
        'partTypes': json['partTypes'] == null ? undefined : ((json['partTypes'] as Array<any>).map(PartTypeResponseFromJSON)),
        'partTypeMeasurementTools': json['partTypeMeasurementTools'] == null ? undefined : ((json['partTypeMeasurementTools'] as Array<any>).map(PartTypeMeasurementToolResponseFromJSON)),
        'partDimensions': json['partDimensions'] == null ? undefined : ((json['partDimensions'] as Array<any>).map(PartDimensionResponseFromJSON)),
        'partDimensionThresholds': json['partDimensionThresholds'] == null ? undefined : ((json['partDimensionThresholds'] as Array<any>).map(PartDimensionThresholdResponseFromJSON)),
        'sites': json['sites'] == null ? undefined : ((json['sites'] as Array<any>).map(SiteResponseFromJSON)),
        'siteDiggingConditions': json['siteDiggingConditions'] == null ? undefined : ((json['siteDiggingConditions'] as Array<any>).map(SiteDiggingConditionResponseFromJSON)),
        'units': json['units'] == null ? undefined : ((json['units'] as Array<any>).map(UnitResponseFromJSON)),
    };
}

export function InspectionSyncItemsResponseToJSON(json: any): InspectionSyncItemsResponse {
    return InspectionSyncItemsResponseToJSONTyped(json, false);
}

export function InspectionSyncItemsResponseToJSONTyped(value?: InspectionSyncItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assets': value['assets'] == null ? undefined : ((value['assets'] as Array<any>).map(AssetResponseToJSON)),
        'assetInspections': value['assetInspections'] == null ? undefined : ((value['assetInspections'] as Array<any>).map(AssetInspectionResponseToJSON)),
        'assetManufacturers': value['assetManufacturers'] == null ? undefined : ((value['assetManufacturers'] as Array<any>).map(AssetManufacturerResponseToJSON)),
        'assetModels': value['assetModels'] == null ? undefined : ((value['assetModels'] as Array<any>).map(AssetModelResponseToJSON)),
        'assetTypes': value['assetTypes'] == null ? undefined : ((value['assetTypes'] as Array<any>).map(AssetTypeResponseToJSON)),
        'customers': value['customers'] == null ? undefined : ((value['customers'] as Array<any>).map(CustomerResponseToJSON)),
        'dataTypes': value['dataTypes'] == null ? undefined : ((value['dataTypes'] as Array<any>).map(DataTypeResponseToJSON)),
        'dimensionTypes': value['dimensionTypes'] == null ? undefined : ((value['dimensionTypes'] as Array<any>).map(DimensionTypeResponseToJSON)),
        'equipmentCategories': value['equipmentCategories'] == null ? undefined : ((value['equipmentCategories'] as Array<any>).map(EquipmentCategoryResponseToJSON)),
        'equipmentConfigurations': value['equipmentConfigurations'] == null ? undefined : ((value['equipmentConfigurations'] as Array<any>).map(EquipmentConfigurationResponseToJSON)),
        'equipments': value['equipments'] == null ? undefined : ((value['equipments'] as Array<any>).map(EquipmentResponseToJSON)),
        'equipmentParts': value['equipmentParts'] == null ? undefined : ((value['equipmentParts'] as Array<any>).map(EquipmentPartResponseToJSON)),
        'equipmentPartConfigurations': value['equipmentPartConfigurations'] == null ? undefined : ((value['equipmentPartConfigurations'] as Array<any>).map(EquipmentPartConfigurationResponseToJSON)),
        'equipmentTypes': value['equipmentTypes'] == null ? undefined : ((value['equipmentTypes'] as Array<any>).map(EquipmentTypeResponseToJSON)),
        'inspectionCategories': value['inspectionCategories'] == null ? undefined : ((value['inspectionCategories'] as Array<any>).map(InspectionCategoryResponseToJSON)),
        'inspectionCategoryTypes': value['inspectionCategoryTypes'] == null ? undefined : ((value['inspectionCategoryTypes'] as Array<any>).map(InspectionCategoryTypeResponseToJSON)),
        'inspections': value['inspections'] == null ? undefined : ((value['inspections'] as Array<any>).map(InspectionResponseToJSON)),
        'inspectionStatuses': value['inspectionStatuses'] == null ? undefined : ((value['inspectionStatuses'] as Array<any>).map(InspectionStatusResponseToJSON)),
        'inspectionTypes': value['inspectionTypes'] == null ? undefined : ((value['inspectionTypes'] as Array<any>).map(InspectionTypeResponseToJSON)),
        'mineLocations': value['mineLocations'] == null ? undefined : ((value['mineLocations'] as Array<any>).map(MineLocationResponseToJSON)),
        'observableActionTypes': value['observableActionTypes'] == null ? undefined : ((value['observableActionTypes'] as Array<any>).map(ObservableActionTypeResponseToJSON)),
        'observableItems': value['observableItems'] == null ? undefined : ((value['observableItems'] as Array<any>).map(ObservableItemResponseToJSON)),
        'observableItemActionTypes': value['observableItemActionTypes'] == null ? undefined : ((value['observableItemActionTypes'] as Array<any>).map(ObservableItemActionTypeResponseToJSON)),
        'observableLevels': value['observableLevels'] == null ? undefined : ((value['observableLevels'] as Array<any>).map(ObservableLevelResponseToJSON)),
        'observations': value['observations'] == null ? undefined : ((value['observations'] as Array<any>).map(ObservationResponseToJSON)),
        'partCategories': value['partCategories'] == null ? undefined : ((value['partCategories'] as Array<any>).map(PartCategoryResponseToJSON)),
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(PartResponseToJSON)),
        'partLocations': value['partLocations'] == null ? undefined : ((value['partLocations'] as Array<any>).map(PartLocationResponseToJSON)),
        'partManufacturers': value['partManufacturers'] == null ? undefined : ((value['partManufacturers'] as Array<any>).map(PartManufacturerResponseToJSON)),
        'partTypes': value['partTypes'] == null ? undefined : ((value['partTypes'] as Array<any>).map(PartTypeResponseToJSON)),
        'partTypeMeasurementTools': value['partTypeMeasurementTools'] == null ? undefined : ((value['partTypeMeasurementTools'] as Array<any>).map(PartTypeMeasurementToolResponseToJSON)),
        'partDimensions': value['partDimensions'] == null ? undefined : ((value['partDimensions'] as Array<any>).map(PartDimensionResponseToJSON)),
        'partDimensionThresholds': value['partDimensionThresholds'] == null ? undefined : ((value['partDimensionThresholds'] as Array<any>).map(PartDimensionThresholdResponseToJSON)),
        'sites': value['sites'] == null ? undefined : ((value['sites'] as Array<any>).map(SiteResponseToJSON)),
        'siteDiggingConditions': value['siteDiggingConditions'] == null ? undefined : ((value['siteDiggingConditions'] as Array<any>).map(SiteDiggingConditionResponseToJSON)),
        'units': value['units'] == null ? undefined : ((value['units'] as Array<any>).map(UnitResponseToJSON)),
    };
}

